import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth";
// TABLAS
import TablaCatalogoCuentaContable from "./catalogoActualizarCatCuenta";
import TablaSaldoInicial from "./tablaCargarSaldoIncial";
import TablaVincularCuenta from "./tablaVinculacionCuentas";
import TablaMovimientosTransito from "./tablaMoviTransito";
import TablaSaldpEstadoCuenta from "./tablaSaldoEstadoCuenta";
import TablaAsientoNueva from "./tablaAsientoNueva";
// MODALES
import CargarDesdeEjercicio from "./modalCargarEjercicio";
import { ModalTiOrPag } from "./modalTipoOrdesPago";
import { ModalVincularCaja } from "./modalVincularCaja";
import { ModalVincularObra } from "./modalVincularObra";
import { ModalVincularHacienda } from "./modalVincularHacienda";
import { ModalVincularAvance } from "./modalVincularFondoAvance";
import { ModalContabilizarIngreso } from "./modalContabilizarIngreso";
import CambiarEfiscal from "../configuracionGeneral/modalCambiarEfiscal";
import { CerrarConsiliacion } from "./cerrarConciliacion";
import ImpModal from "./modalImp";
// LAYOUT COMPONENTS
import Menu from "../comun/Menu/Menu";
import Item from "../comun/Menu/Item";
import Usuarios from "./Configuracion/Usuarios/Usuarios.jsx";
import CambiarClaveSupervisorContabilidad from "./Configuracion/CambiarClaveSupervisorContabilidad/CambiarClaveSupervisorContabilidad.jsx";
import Footer from "../Footer.js";
import TablaUsuarioContabilidad from "./tablaUsuarioContabilidad.js";
import imgContabilidad from "../../imagenes/fd_contabilidad.png";

function MenuPrincipaContFis() {
  const { user } = useContext(AuthContext);

  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [idefiscal] = useState(JSON.parse(localStorage.getItem("idefiscal")));
  const [desde, setDesde] = useState("0");
  let op = require("../../../src/modulos/datos");

  const actualizacionItem = {
    title: "Actualizacion",
    icon: "fas fa-pen-alt me-2",
    drop: [
      {
        title: "Catalogo de cuentas contables >",
        icon: "fa fa-map me-2",
        subDrop: [
          {
            title: "Cargar desde el ejercio fiscal",
            icon: "fa fa-map me-2",
            itemClickValue: 37,
          },
          {
            title: "Actualizar catalogo cuenta",
            icon: "fa fa-map me-2",
            itemClickValue: 1,
          },
        ],
      },
      {
        title: "Saldos Iniciales >",
        icon: "fa fa-map me-2",
        subDrop: [
          /* {
            title: "Cargar desde el ejercio fiscal",
            icon: "fa fa-map me-2",
            itemClickValue: 38,
          }, */
          {
            title: "Cargar saldos iniciales",
            icon: "fa fa-map me-2",
            itemClickValue: 2,
          },
        ],
      },
      {
        title: "Vinculaciones de cuentas >",
        icon: "fa fa-map me-2",
        subDrop: [
          {
            title: "Cargar desde el ejercio fiscal",
            icon: "fa fa-map me-2",
            itemClickValue: 39,
          },
          {
            title: "Vincular cuentas",
            icon: "fa fa-map me-2",
            itemClickValue: 3,
          },
          {
            title: "Vincular tipo de orden de pago",
            icon: "fa fa-map me-2",
            itemClickValue: 4,
          },
          {
            title: "Vincular caja",
            icon: "fa fa-map me-2",
            itemClickValue: 5,
          },
          {
            title: "Vincular contratos de obras/servicios",
            icon: "fa fa-map me-2",
            itemClickValue: 6,
          },
          {
            title: "Vincular cuenta de hacienda",
            icon: "fa fa-map me-2",
            itemClickValue: 7,
          },
          {
            title: "Vincular fonde de avance",
            icon: "fa fa-map me-2",
            itemClickValue: 8,
          },
        ],
      },
      {
        title: "Asientos",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 9,
      },
      {
        title: "Contabilizar ingresos",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 10,
      },
      {
        title: "Movimientos bancarios en transito",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 11,
      },
      {
        title: "Saldo segun estado de cuenta",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 12,
      },
      {
        title: "Cerrar mes de conciliacion/asiento",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 13,
      },
      {
        title: "Abrir mes de conciliacion/asiento",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 14,
      },
      {
        title: "Cambio de año presupuestario",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 15,
      },
    ],
  };
  const imprimirItem = {
    title: "Imprimir",
    icon: "fas fa-print me-2",
    drop: [
      {
        title: "Catalogo de cuenta contable",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 18,
      },
      {
        title: "Plan unico de cuentas",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 19,
      },
      {
        title: "Saldos iniciales de cuentas",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 20,
      },
      {
        title: "Saldos de cuenta contable",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 21,
      },
      {
        title: "Vinculaciones >",
        icon: "fa fa-file-powerpoint me-2",
        subDrop: [
          {
            title: "Vinculacion de cuentas presupuestarias",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 22,
          },
          {
            title: "Vinculacion de cuentas bancarias",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 23,
          },
          {
            title: "Vinculacion de tipos de ordenes-caja-hacienda",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 24,
          },
          {
            title: "Vinculacion de retenciones",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 25,
          },
          {
            title: "Vinculacion de bienes",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 26,
          },
          {
            title: "Cuentas presupuestarias sin pagar",
            icon: "fa fa-file-powerpoint me-2",
            itemClickValue: 27,
          },
        ],
      },
      {
        title: "Balance de comprobacion",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 28,
      },
      {
        title: "Balance general",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 29,
      },
      {
        title: "Asientos contables",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 30,
      },
      {
        title: "Estado de movimientos",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 31,
      },
      {
        title: "Mayor analitico",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 32,
      },
      {
        title: "Asientos contables del egreso",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 33,
      },
      {
        title: "Recuperacion de deudas",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 34,
      },
    ],
  };

  const configuracionItem = {
    title: "configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 35,
      },
      {
        title: "Cambiar Clave Supervisor Contabilidad",
        icon: "fa fa-key me-2",
        itemClickValue: 36,
      },
    ],
  };

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgContabilidad}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };

  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);
  const [imp, setImp] = useState(0);

  // FUNCIONALIDAD DE IMPRIMIR
  useEffect(() => {
    setImp(tabla);
    if (tabla === 18) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Catalogo_Cuenta_Contable&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 19) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Plan_Cuenta_Contable&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 20) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Saldos_Iniciales_Cuenta_Contable&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 21) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Saldos_Cuenta_Contable&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 22) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_Vinculacion_Cuentas&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 23) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_Vinculacion_Cuentas_Bancarias&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 24) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_Vinculacion_Tipo_Ordenes&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 25) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_Vinculacion_Retenciones&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 26) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_Vinculacion_Bienes&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla === 27) {
      window.open(
        `${
          op.reportes + "/contabilidadfiscal?"
        }reporte=Conta_CuentasPresu_Sin_Vincular&efiscal=${idefiscal}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
    if (tabla >= 28 && tabla < 35) {
      setTabla(17);
    }
    if (tabla === 37) {
      setDesde("1");
      setTabla(16);
    }
    if (tabla === 38) {
      setDesde("2");
      setTabla(16);
    }
    if (tabla === 39) {
      setDesde("3");
      setTabla(16);
    }
  }, [tabla]);

  const vista = {
    0: <PorDefecto />,
    1: <TablaCatalogoCuentaContable setTabla={setTabla} />,
    2: <TablaSaldoInicial setTabla={setTabla} />,
    3: <TablaVincularCuenta setTabla={setTabla} />,
    4: <ModalTiOrPag setShow={setShow} show={show} />,
    5: <ModalVincularCaja setShow={setShow} show={show} />,
    6: <ModalVincularObra setShow={setShow} show={show} />,
    7: <ModalVincularHacienda setShow={setShow} show={show} />,
    8: <ModalVincularAvance setShow={setShow} show={show} />,
    9: <TablaAsientoNueva setTabla={setTabla} />,
    10: <ModalContabilizarIngreso setShow={setShow} show={show} desde={2} />,
    11: <TablaMovimientosTransito setTabla={setTabla} />,
    12: <TablaSaldpEstadoCuenta setTabla={setTabla} />,
    13: <CerrarConsiliacion setShow={setShow} show={show} tabla={tabla} />,
    14: <CerrarConsiliacion setShow={setShow} show={show} tabla={tabla} />,
    15: <CambiarEfiscal setShow={setShow} show={show} />,
    16: (
      <CargarDesdeEjercicio setShow={setShow} show={show} operacion={desde} />
    ),
    17: <ImpModal setShow={setShow} show={show} operacion={imp} />,
    35: (
      <TablaUsuarioContabilidad
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    36: (
      <CambiarClaveSupervisorContabilidad
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
  };

  return (
    user && (
      <div>
        {/* MENU AND HEADER */}
        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item
            item={actualizacionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/inicio"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        {/* ROUTING */}
        <section
          className="col-12 m-0 p-0 d-flex align-items-center justify-content-center"
          style={{ height: "90dvh" }}
        >
          {vista[tabla] !== undefined ? vista[tabla] : vista[0]}
        </section>
        <Footer />
      </div>
    )
  );
}
export default MenuPrincipaContFis;
